export default __webpack_public_path__ + "static/education-6e10ce8da06a7ab7a0442709639d6352.jpg";